<ccl-content-section>
    <div class="row row--builder">
        <div class="col col-sm-6">
            <h3>Speaker Template</h3>
        </div>
    </div>
    <div class="row row--builder">
        <div class="col col-sm-6">
            <div class="c-title--subsection">TEMPLATE USED</div>
            <span>{{ templateStyles[speakerConfig.layout] }}</span>
        </div>
        <div class="col col-sm-6">
            <ccl-basic-button
                (clickEvent)="openConfigDrawer('template', $event, null)"
                buttonStyle="c-btn--secondary pull-right"
                >Change to a Different Template
            </ccl-basic-button>
        </div>
    </div>
    <p></p>
    <div class="row row--builder ">
        <div class="col col-sm-6 text-right "></div>
        <div *ngIf="speakerTemplateType == 'list'" class="row row--builder list-layout">
            <div class="col col-sm-12 ">
                <div
                    [class.c-box]="!hover"
                    [class.c-box-nohover]="hover"
                    (cclClick)="openConfigDrawer('region', $event, 'body')"
                    title="Edit Region"
                >
                    <div
                        *ngIf="speakerConfig.layout == 'l_circular'"
                        class="layout-box"
                        [ngStyle]="{
                            'background-color': speakerConfig.catalogConfig.body.regionConfig.background,
                            margin: speakerConfig.catalogConfig.body.regionConfig.margin,
                            padding: speakerConfig.catalogConfig.body.regionConfig.padding,
                            'border-radius': speakerConfig.catalogConfig.body.regionConfig.corner
                        }"
                    >
                        <div class="row">
                            <div class="col-sm-12 col-xs-12">
                                <div
                                    class="editable img"
                                    [ngStyle]="{
                                        height:
                                            +speakerConfig.catalogConfig.body.imageConfig.height.slice(0, -2) +
                                            +speakerConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                            14 +
                                            'px',
                                        width:
                                            +speakerConfig.catalogConfig.body.imageConfig.width.slice(0, -2) +
                                            +speakerConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                            14 +
                                            'px',
                                        overflow: 'hidden'
                                    }"
                                    (cclClick)="openConfigDrawer('img', $event, 'body')"
                                    title="Edit Speaker Image"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="img-info">
                                        <div
                                            class="img-content"
                                            [ngStyle]="{
                                                padding: '0px',
                                                height: speakerConfig.catalogConfig.body.imageConfig.height,
                                                width: speakerConfig.catalogConfig.body.imageConfig.width,
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.imageConfig.background,
                                                margin: speakerConfig.catalogConfig.body.imageConfig.margin,
                                                'border-radius':
                                                    this.speakerConfig.layout == 'l_circular'
                                                        ? speakerConfig.catalogConfig.body.imageConfig.height
                                                        : '0px'
                                            }"
                                        >
                                            <div
                                                *ngIf="
                                                    speakerConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                    'dynamic_img'
                                                "
                                                [innerHTML]="basedOnImageName['body'] | safeHtml"
                                            ></div>

                                            <span
                                                *ngIf="
                                                    speakerConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                    'speaker_img'
                                                "
                                                [ngStyle]="{
                                                    display: 'inline-block',
                                                    'margin-top':
                                                        'calc(' +
                                                        speakerConfig.catalogConfig.body.imageConfig.height +
                                                        ' / 2 - 20px)'
                                                }"
                                                class="fs10"
                                                [innerHTML]="basedOnImageName['body'] | safeHtml"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    [ngStyle]="{
                                        width:
                                            'calc(96% - ' +
                                            speakerConfig.catalogConfig.body.imageConfig.width +
                                            ' - ' +
                                            speakerConfig.catalogConfig.body.imageConfig.margin +
                                            ' - ' +
                                            speakerConfig.catalogConfig.body.imageConfig.margin +
                                            ')'
                                    }"
                                    class="editable text"
                                    (cclClick)="openConfigDrawer('html', $event, 'body')"
                                    title="Edit Speaker Content"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="text-info text-content-collapsed">
                                        <div
                                            class="text-content"
                                            [innerHTML]="bodyLayout | safeHtml"
                                            [ngStyle]="{
                                                position: 'relative',
                                                'word-wrap': 'break-word',
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.textConfig.background,
                                                color: speakerConfig.catalogConfig.body.textConfig.textColor
                                            }"
                                        ></div>
                                    </div>
                                </div>
                                <!-- <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template> -->
                                <div class="clearfix "></div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="speakerConfig.layout == 'l_square'"
                        class="layout-box"
                        [ngStyle]="{
                            'background-color': speakerConfig.catalogConfig.body.regionConfig.background,
                            margin: speakerConfig.catalogConfig.body.regionConfig.margin,
                            padding: speakerConfig.catalogConfig.body.regionConfig.padding,
                            'border-radius': speakerConfig.catalogConfig.body.regionConfig.corner
                        }"
                    >
                        <div class="row">
                            <div class="col-sm-12 col-xs-12">
                                <div
                                    class="editable img"
                                    (cclClick)="openConfigDrawer('img', $event, 'body')"
                                    title="Edit Speaker Image"
                                    [ngStyle]="{
                                        height:
                                            +speakerConfig.catalogConfig.body.imageConfig.height.slice(0, -2) +
                                            +speakerConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                            14 +
                                            'px',
                                        width:
                                            +speakerConfig.catalogConfig.body.imageConfig.width.slice(0, -2) +
                                            +speakerConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                            14 +
                                            'px',
                                        overflow: 'hidden'
                                    }"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="img-info">
                                        <div
                                            class="img-content"
                                            [ngStyle]="{
                                                padding: '0px',
                                                height: speakerConfig.catalogConfig.body.imageConfig.height,
                                                width: speakerConfig.catalogConfig.body.imageConfig.width,
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.imageConfig.background,
                                                margin: speakerConfig.catalogConfig.body.imageConfig.margin,
                                                'border-radius':
                                                    this.speakerConfig.layout == 'l_circular'
                                                        ? speakerConfig.catalogConfig.body.imageConfig.height
                                                        : '0px'
                                            }"
                                        >
                                            <div
                                                *ngIf="
                                                    speakerConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                    'dynamic_img'
                                                "
                                                [innerHTML]="basedOnImageName['body'] | safeHtml"
                                            ></div>

                                            <span
                                                *ngIf="
                                                    speakerConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                    'speaker_img'
                                                "
                                                [ngStyle]="{
                                                    display: 'inline-block',
                                                    'margin-top':
                                                        'calc(' +
                                                        speakerConfig.catalogConfig.body.imageConfig.height +
                                                        ' / 2 - 20px)'
                                                }"
                                                class="fs10"
                                                [innerHTML]="basedOnImageName['body'] | safeHtml"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    [ngStyle]="{
                                        width:
                                            'calc(96% - ' +
                                            speakerConfig.catalogConfig.body.imageConfig.width +
                                            ' - ' +
                                            speakerConfig.catalogConfig.body.imageConfig.margin +
                                            ' - ' +
                                            speakerConfig.catalogConfig.body.imageConfig.margin +
                                            ')'
                                    }"
                                    class="editable text"
                                    (cclClick)="openConfigDrawer('html', $event, 'body')"
                                    title="Edit Speaker Content"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="text-info text-content-collapsed">
                                        <div
                                            class="text-content"
                                            [innerHTML]="bodyLayout | safeHtml"
                                            [ngStyle]="{
                                                position: 'relative',
                                                'word-wrap': 'break-word',
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.textConfig.background,
                                                color: speakerConfig.catalogConfig.body.textConfig.textColor
                                            }"
                                        ></div>
                                    </div>
                                </div>
                                <!-- <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template> -->
                            </div>
                        </div>
                        <div class="clearfix "></div>
                    </div>
                    <div
                        *ngIf="speakerConfig.layout == 'l_noimage'"
                        class="layout-box"
                        [ngStyle]="{
                            'background-color': speakerConfig.catalogConfig.body.regionConfig.background,
                            margin: speakerConfig.catalogConfig.body.regionConfig.margin,
                            padding: speakerConfig.catalogConfig.body.regionConfig.padding,
                            'border-radius': speakerConfig.catalogConfig.body.regionConfig.corner
                        }"
                    >
                        <div class="row mar-right0">
                            <div class="col-sm-12 col-xs-12">
                                <div
                                    class="editable text w100"
                                    (cclClick)="openConfigDrawer('html', $event, 'body')"
                                    title="Edit Speaker Content"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="text-info text-content-collapsed">
                                        <div
                                            class="text-content"
                                            [innerHTML]="bodyLayout | safeHtml"
                                            [ngStyle]="{
                                                position: 'relative',
                                                'word-wrap': 'break-word',
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.textConfig.background,
                                                color: speakerConfig.catalogConfig.body.textConfig.textColor
                                            }"
                                        ></div>
                                    </div>
                                </div>
                                <!-- <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template> -->
                            </div>
                        </div>
                        <div class="clearfix "></div>
                    </div>
                    <div
                        *ngIf="speakerConfig.layout == 'l_banner'"
                        class="layout-box"
                        [ngStyle]="{
                            'background-color': speakerConfig.catalogConfig.body.regionConfig.background,
                            margin: speakerConfig.catalogConfig.body.regionConfig.margin,
                            padding: speakerConfig.catalogConfig.body.regionConfig.padding,
                            'border-radius': speakerConfig.catalogConfig.body.regionConfig.corner
                        }"
                    >
                        <div class="row">
                            <div class="col-sm-12 col-xs-12" (cclClick)="openConfigDrawer('img', $event, 'body')"
                            title="Edit Speaker Image">
                                <div
                                    class="editable banner-img-container"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div
                                        class="banner-img"
                                        [ngStyle]="{
                                            margin: speakerConfig.catalogConfig.header.imageConfig.margin
                                        }"
                                    >
                                        <div
                                            [ngStyle]="{'background-color':speakerConfig.catalogConfig.body.imageConfig.background}"
                                        >
                                            <img
                                                style="opacity:.8"
                                                alt="Banner"
                                                [src]="speakerConfig.catalogConfig.body.imageConfig.banner"
                                                class="w100 img-fluid"
                                                *ngIf="speakerConfig.catalogConfig.body.imageConfig.banner != null"
                                            />
                                        </div>
                                        <div
                                            class="text-center aqua-color"
                                            *ngIf="speakerConfig.catalogConfig.body.imageConfig.banner == null"
                                        >
                                            Click to upload static image.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-xs-12">
                                <div
                                    class="editable text w100 banner-sibling"
                                    (cclClick)="openConfigDrawer('html', $event, 'body')"
                                    title="Edit Speaker Content"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="text-info text-content-collapsed">
                                        <div
                                            class="text-content"
                                            [innerHTML]="bodyLayout | safeHtml"
                                            [ngStyle]="{
                                                position: 'relative',
                                                'word-wrap': 'break-word',
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.textConfig.background,
                                                color: speakerConfig.catalogConfig.body.textConfig.textColor
                                            }"
                                        ></div>
                                    </div>
                                </div>

                                <!-- <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template> -->
                            </div>
                        </div>
                        <div class="clearfix "></div>
                    </div>
                    <div class="clearfix "></div>
                </div>
            </div>
        </div>

        <div *ngIf="speakerTemplateType == 'card'" class="row row--builder card-layout justify-content-md-center">
            <div class="col col-sm-6 ">
                <div
                    [class.c-box]="!hover"
                    [class.c-box-nohover]="hover"
                    (cclClick)="openConfigDrawer('region', $event, 'body')"
                    title="Edit Region"
                >
                    <div
                        *ngIf="speakerConfig.layout == 'l_circular'"
                        class="layout-box"
                        [ngStyle]="{
                            'background-color': speakerConfig.catalogConfig.body.regionConfig.background,
                            margin: speakerConfig.catalogConfig.body.regionConfig.margin,
                            padding: speakerConfig.catalogConfig.body.regionConfig.padding,
                            'border-radius': speakerConfig.catalogConfig.body.regionConfig.corner
                        }"
                    >
                        <div class="row">
                            <div class="col-sm-12 col-xs-12">
                                <div
                                    class="editable img"
                                    [ngStyle]="{
                                        height:
                                            +speakerConfig.catalogConfig.body.imageConfig.height.slice(0, -2) +
                                            +speakerConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                            14 +
                                            'px',
                                        overflow: 'hidden'
                                    }"
                                    (cclClick)="openConfigDrawer('img', $event, 'body')"
                                    title="Edit Speaker Image"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="img-info">
                                        <div
                                            class="img-content"
                                            [ngStyle]="{
                                                padding: '0px',
                                                height: speakerConfig.catalogConfig.body.imageConfig.height,
                                                width: speakerConfig.catalogConfig.body.imageConfig.width,
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.imageConfig.background,
                                                margin: speakerConfig.catalogConfig.body.imageConfig.margin,
                                                'border-radius':
                                                    this.speakerConfig.layout == 'l_circular'
                                                        ? speakerConfig.catalogConfig.body.imageConfig.height
                                                        : '0px'
                                            }"
                                        >
                                            <div
                                                *ngIf="
                                                    speakerConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                    'dynamic_img'
                                                "
                                                [innerHTML]="basedOnImageName['body'] | safeHtml"
                                            ></div>

                                            <span
                                                *ngIf="
                                                    speakerConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                    'speaker_img'
                                                "
                                                [ngStyle]="{
                                                    display: 'inline-block',
                                                    'margin-top':
                                                        'calc(' +
                                                        speakerConfig.catalogConfig.body.imageConfig.height +
                                                        ' / 2 - 20px)'
                                                }"
                                                class="fs10"
                                                [innerHTML]="basedOnImageName['body'] | safeHtml"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="editable text"
                                    (cclClick)="openConfigDrawer('html', $event, 'body')"
                                    title="Edit Speaker Content"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="text-info text-content-collapsed">
                                        <div
                                            class="text-content"
                                            [innerHTML]="bodyLayout | safeHtml"
                                            [ngStyle]="{
                                                position: 'relative',
                                                'word-wrap': 'break-word',
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.textConfig.background,
                                                color: speakerConfig.catalogConfig.body.textConfig.textColor
                                            }"
                                        ></div>
                                    </div>
                                </div>
                                <div class="clearfix "></div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="speakerConfig.layout == 'l_square'"
                        class="layout-box"
                        [ngStyle]="{
                            'background-color': speakerConfig.catalogConfig.body.regionConfig.background,
                            margin: speakerConfig.catalogConfig.body.regionConfig.margin,
                            padding: speakerConfig.catalogConfig.body.regionConfig.padding,
                            'border-radius': speakerConfig.catalogConfig.body.regionConfig.corner
                        }"
                    >
                        <div class="row">
                            <div class="col-sm-12 col-xs-12">
                                <div
                                    class="editable img"
                                    (cclClick)="openConfigDrawer('img', $event, 'body')"
                                    title="Edit Speaker Image"
                                    [ngStyle]="{
                                        height:
                                            +speakerConfig.catalogConfig.body.imageConfig.height.slice(0, -2) +
                                            +speakerConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                            14 +
                                            'px',
                                        overflow: 'hidden'
                                    }"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="img-info">
                                        <div
                                            class="img-content"
                                            [ngStyle]="{
                                                padding: '0px',
                                                height: speakerConfig.catalogConfig.body.imageConfig.height,
                                                width: speakerConfig.catalogConfig.body.imageConfig.width,
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.imageConfig.background,
                                                margin: speakerConfig.catalogConfig.body.imageConfig.margin,
                                                'border-radius':
                                                    this.speakerConfig.layout == 'l_circular'
                                                        ? speakerConfig.catalogConfig.body.imageConfig.height
                                                        : '0px'
                                            }"
                                        >
                                            <div
                                                *ngIf="
                                                    speakerConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                    'dynamic_img'
                                                "
                                                [innerHTML]="basedOnImageName['body'] | safeHtml"
                                            ></div>

                                            <span
                                                *ngIf="
                                                    speakerConfig.catalogConfig['body'].imageConfig.basedOn ==
                                                    'speaker_img'
                                                "
                                                [ngStyle]="{
                                                    display: 'inline-block',
                                                    'margin-top':
                                                        'calc(' +
                                                        speakerConfig.catalogConfig.body.imageConfig.height +
                                                        ' / 2 - 20px)'
                                                }"
                                                class="fs10"
                                                [innerHTML]="basedOnImageName['body'] | safeHtml"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="editable text"
                                    (cclClick)="openConfigDrawer('html', $event, 'body')"
                                    title="Edit Speaker Content"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="text-info text-content-collapsed">
                                        <div
                                            class="text-content"
                                            [innerHTML]="bodyLayout | safeHtml"
                                            [ngStyle]="{
                                                position: 'relative',
                                                'word-wrap': 'break-word',
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.textConfig.background,
                                                color: speakerConfig.catalogConfig.body.textConfig.textColor
                                            }"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix "></div>
                    </div>
                    <div
                        *ngIf="speakerConfig.layout == 'l_noimage'"
                        class="layout-box"
                        [ngStyle]="{
                            'background-color': speakerConfig.catalogConfig.body.regionConfig.background,
                            margin: speakerConfig.catalogConfig.body.regionConfig.margin,
                            padding: speakerConfig.catalogConfig.body.regionConfig.padding,
                            'border-radius': speakerConfig.catalogConfig.body.regionConfig.corner
                        }"
                    >
                        <div class="row mar-right0">
                            <div class="col-sm-12 col-xs-12">
                                <div
                                    class="editable text w100"
                                    (cclClick)="openConfigDrawer('html', $event, 'body')"
                                    title="Edit Speaker Content"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="text-info text-content-collapsed">
                                        <div
                                            class="text-content"
                                            [innerHTML]="bodyLayout | safeHtml"
                                            [ngStyle]="{
                                                position: 'relative',
                                                'word-wrap': 'break-word',
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.textConfig.background,
                                                color: speakerConfig.catalogConfig.body.textConfig.textColor
                                            }"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix "></div>
                    </div>
                    <div
                        *ngIf="speakerConfig.layout == 'l_banner'"
                        class="layout-box"
                        [ngStyle]="{
                            'background-color': speakerConfig.catalogConfig.body.regionConfig.background,
                            margin: speakerConfig.catalogConfig.body.regionConfig.margin,
                            padding: speakerConfig.catalogConfig.body.regionConfig.padding,
                            'border-radius': speakerConfig.catalogConfig.body.regionConfig.corner
                        }"
                    >
                        <div class="row">
                            <div class="col-sm-12 col-xs-12" (cclClick)="openConfigDrawer('img', $event, 'body')"
                            title="Edit Speaker Image">
                                <div
                                    class="editable banner-img-container"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div
                                        class="banner-img"
                                        [ngStyle]="{
                                            margin: speakerConfig.catalogConfig.header.imageConfig.margin
                                        }"
                                    >
                                        <div
                                            [ngStyle]="{'background-color':speakerConfig.catalogConfig.body.imageConfig.background}"
                                        >
                                            <img
                                                style="opacity:.8"
                                                alt="Banner"
                                                [src]="speakerConfig.catalogConfig.body.imageConfig.banner"
                                                class="w100 img-fluid"
                                                *ngIf="speakerConfig.catalogConfig.body.imageConfig.banner != null"
                                            />
                                        </div>
                                        <div
                                            class="text-center aqua-color"
                                            *ngIf="speakerConfig.catalogConfig.body.imageConfig.banner == null"
                                        >
                                            Click to upload static image.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-xs-12">
                                <div
                                    class="editable text w100 banner-sibling"
                                    (cclClick)="openConfigDrawer('html', $event, 'body')"
                                    title="Edit Speaker Content"
                                    (mouseout)="hover = false"
                                    (mouseover)="hover = true"
                                >
                                    <div class="text-info text-content-collapsed">
                                        <div
                                            class="text-content"
                                            [innerHTML]="bodyLayout | safeHtml"
                                            [ngStyle]="{
                                                position: 'relative',
                                                'word-wrap': 'break-word',
                                                'background-color':
                                                    speakerConfig.catalogConfig.body.textConfig.background,
                                                color: speakerConfig.catalogConfig.body.textConfig.textColor
                                            }"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix "></div>
                    </div>
                    <div class="clearfix "></div>
                </div>
            </div>
        </div>
    </div>
</ccl-content-section>

<ng-template #buttonConfig>
    <div class="button-config-handler" *ngIf="false" (mouseout)="hover = false" (mouseover)="hover = true">
        <div class="c-box" (cclClick)="openConfigDrawer('button', $event, 'button')" title="Edit Icons">
            <span><i class="fa fa-lg" [ngClass]="speakerConfig.catalogConfig.buttonConfig.favIcon" title="Favorite"></i></span>
            <span><i class="fa fa-lg" [ngClass]="speakerConfig.catalogConfig.buttonConfig.regIcon" title="Register"></i></span>
        </div>
    </div>
</ng-template>
